export enum PerformanceCardGroupType {
    'Active' = 'Devam Ediyor',
    'Completed' = 'Tamamlandı',
    'Cancelled' = 'İptal Edildi',
}